import React, { useMemo } from 'react';
import GenericDropdown from '@shared/components/GenericDropdown';

const OrderBySelect = ({ orderHotelsBy, handleSetOrderHotelsBy }) => {
  const orderItems = useMemo(
    () => [
      { id: 1, fragments: [{ text: 'Destacados' }] },
      { id: 2, fragments: [{ text: 'Precio más bajo' }] },
      { id: 3, fragments: [{ text: 'Precio más alto' }] },
    ],
    []
  );

  const selectedItem = useMemo(
    () => orderItems.find(item => item.id === orderHotelsBy) || null,
    [orderHotelsBy, orderItems]
  );

  return (
    <GenericDropdown
      items={orderItems}
      selectedItem={selectedItem}
      onSelect={item => handleSetOrderHotelsBy(item.id)}
      buttonLabel="Ordenar por"
      isPrimaryBorder={true}
    />
  );
};

export default OrderBySelect;
